import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Homepage from "./components/Homepage";
import FeaturesPage from "./components/FeaturesPage";
import UseCasesPage from "./components/UseCasesPage";
import ContactPage from "./components/ContactPage";
import QuizPage from "./components/QuizPage";
import QuizResultsDemo from "./components/QuizResultsDemo";
import AboutPage from "./components/AboutPage";
import PrivacyPage from "./components/PrivacyPage";
import TermsPage from "./components/TermsPage";
import CookiePage from "./components/CookiePage";
import ConciergePage from "./components/products/ConciergePage";
import VioCoachPage from "./components/products/VioCoachPage";
import VioConcierge from "./components/products/VioConcierge";
import VioConciergeTest from "./components/products/VioConciergeTest";
import VioSuiteHomepage from "./components/VioSuiteHomepage";
import PRDDocuments from "./components/PRDDocuments";
import HRConsultancyPage from "./components/HRConsultancyPage";
import ErrorBoundary from "./components/ErrorBoundary";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

async function helloWorldApi() {
  try {
    if (!BACKEND_URL) {
      console.warn('Backend URL not configured');
      return;
    }
    
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000); // 5 second timeout
    
    const response = await fetch(`${BACKEND_URL}/api/`, {
      signal: controller.signal
    });
    
    clearTimeout(timeoutId);
    
    if (response.ok) {
      const data = await response.json();
      console.log('Backend connection successful:', data);
    } else {
      console.warn('Backend responded with status:', response.status);
    }
  } catch (error) {
    if (error.name === 'AbortError') {
      console.warn('Backend connection timed out');
    } else {
      console.warn('Backend connection failed:', error.message);
    }
  }
}

function App() {
  useEffect(() => {
    helloWorldApi();
  }, []);

  return (
    <HelmetProvider>
      <ErrorBoundary>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<VioSuiteHomepage />} />
              <Route path="/features" element={<FeaturesPage />} />
              <Route path="/use-cases" element={<UseCasesPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/cookies" element={<CookiePage />} />
              <Route path="/products/vioqbase" element={<Homepage />} />
              <Route path="/products/vioreceptionist" element={<ConciergePage />} />
              <Route path="/products/viocoach" element={<VioCoachPage />} />
              <Route path="/products/vioconcierge" element={<VioConcierge />} />
              <Route path="/products/vioconcierge-test" element={<VioConciergeTest />} />
              <Route path="/viosuite-preview" element={<VioSuiteHomepage />} />
              <Route path="/prd-documents" element={<PRDDocuments />} />
              <Route path="/hr-consultancy" element={<HRConsultancyPage />} />
              <Route path="/quiz" element={<QuizPage />} />
              <Route path="/quiz-results" element={<QuizResultsDemo />} />
            </Routes>
          </BrowserRouter>
        </div>
      </ErrorBoundary>
    </HelmetProvider>
  );
}

export default App;